import { apiClient } from './api';

export interface DashboardStats {
  todayStats: { revenue: number; appointments: number; newCustomers: number };
  weeklyStats: { revenue: number; appointments: number; newCustomers: number };
  monthlyStats: { revenue: number; appointments: number; newCustomers: number };
}

export interface TrendData {
  date: string;
  revenue: number;
  appointments: number;
  newCustomers: number;
}

export interface RevenueAnalytics {
  currentPeriod: { daily: number; weekly: number; monthly: number };
  metrics: { revenueGrowthRate: number; averageTransactionValue: number };
  trends: { date: string; revenue: number }[];
  growth: { rate: number; averageTransactionValue: number };
}

class AnalyticsService {
  private baseUrl = '/analytics';

  async getDashboardStats(): Promise<DashboardStats> {
    const response = await apiClient.get<any>(`${this.baseUrl}/dashboard`);
    const data = (response as any)?.data ?? response;
    return data ?? {
      todayStats: { revenue: 0, appointments: 0, newCustomers: 0 },
      weeklyStats: { revenue: 0, appointments: 0, newCustomers: 0 },
      monthlyStats: { revenue: 0, appointments: 0, newCustomers: 0 },
    };
  }

  async getRevenueAnalytics(): Promise<RevenueAnalytics> {
    const response = await apiClient.get<any>(`${this.baseUrl}/revenue`);
    const data = (response as any)?.data ?? response;
    return data ?? {
      currentPeriod: { daily: 0, weekly: 0, monthly: 0 },
      metrics: { revenueGrowthRate: 0, averageTransactionValue: 0 },
      trends: [],
      growth: { rate: 0, averageTransactionValue: 0 },
    };
  }

  async getTrendData(days = 30): Promise<TrendData[]> {
    const response = await apiClient.get<any>(`${this.baseUrl}/trends?days=${days}`);
    const data = (response as any)?.data ?? response;
    return Array.isArray(data) ? data : data?.trends ?? [];
  }
}

export const analyticsService = new AnalyticsService();
